/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NetopiaCardPaymentInitiationRequest } from '@well/domain';

@Injectable({providedIn: "root"})
export class PaymentMethodRedirectService {

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  public navigateToPaymentWebsite(request: NetopiaCardPaymentInitiationRequest){
    const form = this.document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute(
      "action",
      request.paymentUrl
    );
    const inputConfig = {
      env_key: request.env_key,
      data: request.data
    }
    Object.keys(inputConfig).forEach((key) => {
      const value = inputConfig[key];
      const inputElement = this.document.createElement("input");
      inputElement.type = "hidden";
      inputElement.name = key;
      inputElement.value = value;
      form.appendChild(inputElement);
    });

    this.document.body.appendChild(form);
    form.submit();
  }

}
